module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-9.7213af99.jpg";